import { render, staticRenderFns } from "./accountsDeposits.vue?vue&type=template&id=c72843b6"
import script from "./accountsDeposits.vue?vue&type=script&lang=js"
export * from "./accountsDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports